import { IconCheckDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import classes from './InfoItems.module.scss'

interface InfoItem {
  title: string
  description: string
}

interface InfoItemsProps {
  shortVersion?: boolean
  className?: string
}

const InfoItems = ({ shortVersion, className }: InfoItemsProps) => {
  const { t } = useTranslation('@mc/next')
  const infoItems: InfoItem[] = t(
    shortVersion
      ? 'enterpriseSelfServe.about.info.shortItems'
      : 'enterpriseSelfServe.about.info.items',
    { returnObjects: true },
  )

  return (
    <div className={`mc-pt-8 ${className}`} data-testid='self-serve-info-items'>
      {infoItems.map(({ title, description }, index) => (
        <div
          className={`d-flex ${index < infoItems.length - 1 && 'mc-mb-4'}`}
          key={title}
        >
          <IconCheckDefault
            size={2}
            className='mc-text-color--success mc-mr-2'
          />
          <div>
            <p className={`mc-text-h6 ${shortVersion && classes.shortTitle}`}>
              {title}
            </p>
            <p className='mc-mt-1 mc-text-h7 mc-text--normal mc-opacity--hinted'>
              {description}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default InfoItems
